import { render, staticRenderFns } from "./CartActivity.vue?vue&type=template&id=088db76e"
import script from "./CartActivity.vue?vue&type=script&lang=ts"
export * from "./CartActivity.vue?vue&type=script&lang=ts"
import style0 from "./CartActivity.vue?vue&type=style&index=0&id=088db76e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports